import { render, staticRenderFns } from "./Setpass.vue?vue&type=template&id=8a3e1ccc&scoped=true"
import script from "./Setpass.vue?vue&type=script&lang=js"
export * from "./Setpass.vue?vue&type=script&lang=js"
import style0 from "./Setpass.vue?vue&type=style&index=0&id=8a3e1ccc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3e1ccc",
  null
  
)

export default component.exports